import { IMAGE_TO_TEXT_CREDIT_GET_FAIL, IMAGE_TO_TEXT_CREDIT_GET_REQUEST, IMAGE_TO_TEXT_CREDIT_GET_SUCCESS, IMAGE_TO_TEXT_DELETE_FAIL, IMAGE_TO_TEXT_DELETE_REQUEST, IMAGE_TO_TEXT_DELETE_SUCCESS, IMAGE_TO_TEXT_FETCH_ALL_FAIL, IMAGE_TO_TEXT_FETCH_ALL_REQUEST, IMAGE_TO_TEXT_FETCH_ALL_SUCCESS, IMAGE_TO_TEXT_FETCH_BY_ID_FAIL, IMAGE_TO_TEXT_FETCH_BY_ID_REQUEST, IMAGE_TO_TEXT_FETCH_BY_ID_SUCCESS } from "../../constants/ImageToOrderConstants";

export const imageToTextFetchAllReducer = (state = { records: [] }, action) => {
    switch (action.type) {
      case IMAGE_TO_TEXT_FETCH_ALL_REQUEST:
        return { loading: true, records: [] };
      case IMAGE_TO_TEXT_FETCH_ALL_SUCCESS:
        return { loading: false, records: action.payload };
      case IMAGE_TO_TEXT_FETCH_ALL_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // Fetch by ID reducer
  export const imageToTextFetchByIdReducer = (state = { record: {} }, action) => {
    switch (action.type) {
      case IMAGE_TO_TEXT_FETCH_BY_ID_REQUEST:
        return { loading: true, record: {} };
      case IMAGE_TO_TEXT_FETCH_BY_ID_SUCCESS:
        return { loading: false, record: action.payload };
      case IMAGE_TO_TEXT_FETCH_BY_ID_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // Delete reducer
  export const imageToTextDeleteReducer = (state = {}, action) => {
    switch (action.type) {
      case IMAGE_TO_TEXT_DELETE_REQUEST:
        return { loading: true };
      case IMAGE_TO_TEXT_DELETE_SUCCESS:
        return { loading: false, success: true };
      case IMAGE_TO_TEXT_DELETE_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };


  export const ImgOrderCreditRecordReducer = (state = { creditRecord: {} }, action) => {
    switch (action.type) {
      case IMAGE_TO_TEXT_CREDIT_GET_REQUEST:
        return { loading: true };
      case IMAGE_TO_TEXT_CREDIT_GET_SUCCESS:
        return { loading: false, creditRecord: action.payload };
      case IMAGE_TO_TEXT_CREDIT_GET_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };